import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlainDocIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.305,
	height: 22.02,
	viewBox: "0 0 18.305 22.02",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "plain-doc-icon",
		transform: "translate(-229 -431)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "icon-back",
			transform: "translate(229 431)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "back-shape",
					d: "M31.276,1.685H21.5a1.282,1.282,0,0,0-1.282,1.282V22.423A1.282,1.282,0,0,0,21.5,23.7H35.41a1.282,1.282,0,0,0,1.282-1.282V7.1Z",
					transform: "translate(-18.387 -1.685)",
					fill: "#f7f6f8"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "corner-shadow",
					d: "M160.554,61.4h3.74v3.74Z",
					transform: "translate(-145.99 -55.98)",
					fill: "#eae9ec"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "corner",
					d: "M142.07,1.685V5.82a1.3,1.3,0,0,0,1.3,1.282h4.117Z",
					transform: "translate(-129.182 -1.685)",
					fill: "#d7d6db"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "block_shadow",
					"data-name": "block shadow",
					d: "M34.917,129.774v-7.125a.58.58,0,0,0-.58-.58H20.221v8.285H34.337a.58.58,0,0,0,.58-.58",
					transform: "translate(-18.387 -111.149)",
					fill: "#dee2e6"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "color_block",
					"data-name": "color block",
					d: "M15.95,125.635H.58a.649.649,0,0,1-.58-.7v-8.6a.649.649,0,0,1,.58-.7H15.95a.649.649,0,0,1,.58.7v8.6a.649.649,0,0,1-.58.7",
					transform: "translate(0 -107.299)",
					fill: "#d7d6db"
				})
			]
		})
	})
});
export default SvgPlainDocIcon;
